export default __webpack_public_path__ + "static/media/cq-logo.2f1ea8d4.svg";